import {post} from '@/utils/request';

/**
 * 审核模式屏蔽词清单
 */
export function admin_blockwords_info() {
  return post('admin_blockwords_info')
}
